import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ImgLogo from "../assets/img/atsh/logo.png";
import UserImgDefault from "../assets/img/user.png";
import { openPopup } from "../reducers/popup";
import { POPUP_NAME, STATUS_CAMPAIGN } from "../utilities/constants";
  const UserImgLogin = "https://static2.vieon.vn/vieplay-image/profile_avatar/2023/03/10/w2ygwt6s_vieon_logo_vuong57877023329b92b5e7f96315b38fd1e9.png"
const Header = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state?.user?.profile);
  const statusCampaign = useSelector((state) => state?.user?.statusCampaign);
  const handleVoting = () => {
    if (statusCampaign === STATUS_CAMPAIGN.NOT_STARTED) {
      dispatch(openPopup({ name: POPUP_NAME.SHOW_NOT_STARTED }));
    } else {
      if (!profile?.id) {
        dispatch(openPopup({ name: POPUP_NAME.LOGIN }));
      } 
    }
  };

  const onClickUser = () => {
    dispatch(
      openPopup({
        name: !!profile?.id ? POPUP_NAME.LOGOUT : POPUP_NAME.LOGIN,
      })
    );
  };

  return (
    <header className="z-10 px-4">
      <div
        className={`absolute w-[28px] h-[28px] lg:w-[32px] lg:h-[32px] right-3 top-3 cursor-pointer${
          !!profile?.id ? " opacity-100" : " opacity-50"
        }`}
        onClick={onClickUser}
      >
        <img src={!!profile?.id ? UserImgLogin : UserImgDefault} alt="user" />
      </div>
      <div className="justify-center pt-[6.5vw] mx-auto mb-[8vw]">
        <div className="flex justify-center cursor-pointer w-[50vw] mx-auto z-10">
          <img
            src={ImgLogo}
            onClick={handleVoting}
            className="w-full h-full"
            alt="ATSH 2024"
          />
        </div>
      </div>
      {/* <Brands /> */}
    </header>
  );
};

export default Header;
